export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const jordanPhoneNumberPattern =
  /^(\\+?962|0)?7[789]\\d{7}$|^(\\+?962|0)?6[0-9]\\d{6}$/;
export const isNumber = /^-?\d+$/;
